import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC } from 'react';

import type { Props } from '@/components/EnrolledGroupsBanner/types';
import TreatmentGroupCard from '@/components/TreatmentGroupCard';
import { Spinner, Typography } from '@/ui';

const EnrolledGroupsBanner: FC<Props> = ({
  groups,
  isFetchingNextPage,
  isPending,
  memberFirstName,
  onRemove,
  onSelect,
  sentinelRef
}) => {
  if (groups.length === 0) return null;

  return (
    <section className="space-y-2 rounded-lg border border-green-200 bg-green-50 p-3 dark:border-green-800 dark:bg-green-950/40">
      <div className="flex items-center gap-2 text-green-700 dark:text-green-400">
        <FontAwesomeIcon icon={faCheckCircle} className="h-4 w-4" />
        <Typography variant="body" className="font-medium text-green-700 dark:text-green-400">
          {`Already enrolled in ${groups.length} group${groups.length === 1 ? '' : 's'}`}
        </Typography>
      </div>
      {groups.map((group) => (
        <TreatmentGroupCard
          key={group.id}
          group={group}
          isPending={isPending}
          memberFirstName={memberFirstName}
          onRemove={onRemove}
          onSelect={onSelect}
        />
      ))}
      {sentinelRef && (
        <div ref={sentinelRef} className="flex justify-center py-2">
          {isFetchingNextPage && <Spinner label="Loading more groups..." />}
        </div>
      )}
    </section>
  );
};

export default EnrolledGroupsBanner;
